import React from 'react';
import ReactDOM from 'react-dom';
import Config from '../utils/config';
import '../utils/TweenMax';
import { applyCdnUrl } from '../utils/site-utils';
import LiveChatWidgetSub from './liveChatWidgetSub';

export default class LiveChatWidget extends React.Component {
	handleAction(action) {
		// var _self = this;
		switch (action.text) {
			case 'openChatWin':
				this.openChatWin(action.link);
				break;
			case 'gotoJoin':
				this.gotoJoin();
				break;
			default:
				return;
		}
	}

	openChatWin(link) {
		window.open(
			link,
			'chatWindow',
			'width=430,height=454,resizable=0,scrollbars=no,menubar=no,status=no'
		);
	}

	gotoJoin() {
		this.props.popupDiv(0);
	}

	/**
	* As the livechat display as an icon, collapse the livechat to slide.
	* @param {String} mode      [open or close the livechat]
	* @param {String} direction [the direction of slide action]
    */
	setSidr(mode, direction) {
		const liveMain = ReactDOM.findDOMNode(this.refs.liveMain);
		const simpleMenu = $(ReactDOM.findDOMNode(this.refs.simpleMenu));
		const menuout = ReactDOM.findDOMNode(this.refs.menuout);

		const w = $(liveMain).width();
		let paddingVal =
			direction === 'left' ? $(menuout).css('padding-left') : $(menuout).css('padding-right');
		paddingVal = parseInt(paddingVal);
		const moveVal = mode === 0 ? -w - 10 - paddingVal - 300 : 0 + paddingVal;

		let css = {};
		if (mode === 1) {
			simpleMenu.hide();
			css[direction] = -w;
			css['display'] = 'inline-block';
			TweenMax.set(liveMain, { css: css });
		}
		else {
			css['display'] = '';
			TweenMax.set(liveMain, { css: css });
		}

		css = {};
		css[direction] = moveVal;
		TweenMax.to(liveMain, 0.46, {
			css: css,
			ease: 'easeOutQuart',
			onComplete: function() {
				if (mode === 0) {
					simpleMenu.show();
					simpleMenu.css({ display: '' });
				}
			}
		});
	}

	render() {
		const liveChat = this.props.liveChat;
		const container = liveChat.nodeList.List;
		let subListElements;
		
		if(container.SubList && container.SubList.length > 1 ) {
			subListElements = container.SubList.map(sub => {
				let isShow = true;
				let chatSub = (
					<LiveChatWidgetSub
						key={sub.id}
						onAction={this.handleAction.bind(this, sub.Target)}
						elementSet={sub}
					/>
				);
				if (sub.Login) {
					if (sub.Login === 'false') {
						isShow = !Config.appConfig.Logined;
					} else {
						isShow = Config.appConfig.Logined;
					}
				}
				return isShow && chatSub;
			});
		}
		else {
			let isShow = true;
			let sub = container.SubList;
			if (sub.Login) {
				if (sub.Login === 'false') {
					isShow = !Config.appConfig.Logined;
				} else {
					isShow = Config.appConfig.Logined;
				}
			}
			subListElements = isShow && <LiveChatWidgetSub
				key={sub.id}
				onAction={this.handleAction.bind(this, sub.Target)}
				elementSet={sub}
			/>
		}

		return (
			<div className={this.props.type} ref="menuout">
				<a
					id="simple-menu"
					href="javascript:void(0);"
					className="liveChatSmall menu-button"
					onClick={this.setSidr.bind(this, 1, liveChat.dir)}
					ref="simpleMenu"
				>
					<i className={liveChat.iclass} />
				</a>
				<div className="liveChatDiv" ref="liveMain">
					<a
						id="close-menu-button"
						className="icon-close"
						href="javascript:void(0);"
						onClick={this.setSidr.bind(this, 0, liveChat.dir)}
					/>
					<div className="mainImg">
						<img src={applyCdnUrl(`/${container.ImgSrc}`)} alt="" />
					</div>
					<ul>{subListElements}</ul>
				</div>
			</div>
		);
	}
}
